<template>
  <va-create-layout>
    <Report-form :title="title" :item="item"></Report-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
